import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
// import shared from '../../../utils/shared.js';
import _ from 'lodash';

const BUBBLE_DIAMETER_PERCENT = 8.71416;
const BUBBLE_MAIN_ACTIVE_DIAMETER = 7.6692;
const BUBBLE_WHITE_OPAQUE_DIAMETER = 9.20;

class SmallBubbleSeattle extends Component {
  constructor(props) {
    super(props);
    this._bubbleRef = null;
    this._bubbleRefTimeout = null;
  }

  componentDidMount() {
    this.setupRefs();
  }

  componentDidUpdate() {
    if (this._bubbleRef) {
      this._bubbleRef.addEventListener('click', this.handleClick);
    }
  }

  shouldComponentUpdate() {
    if (this._bubbleRef) {
      this._bubbleRef.removeEventListener('click', this.handleClick);
    }

    return true;
  }

  componentWillUnmount() {
    clearTimeout(this._bubbleRefTimeout);
    if (this._bubbleRef) {
      this._bubbleRef.removeEventListener('click', this.handleClick);
    }
  }

  setupRefs = () => {
    if (this._bubbleRef === null) {
      clearTimeout(this._bubbleRefTimeout);
      this._bubbleRefTimeout = setTimeout(() => {
        this.setupRefs();
      }, 100)
    } else {
      this._bubbleRef.addEventListener('click', this.handleClick);
    }
  }

  handleClick = () => {
    this.props.handleClick(this.props.id);
  }

  render() {
    let diameter = this.props.regionWidth * BUBBLE_DIAMETER_PERCENT / 100;
    let whiteBubbleDiameter = this.props.regionWidth * BUBBLE_WHITE_OPAQUE_DIAMETER / 100;
    let mainActiveBubbleDiameter = this.props.regionWidth * BUBBLE_MAIN_ACTIVE_DIAMETER / 100;
    let fontSize = 10 / 100 * diameter; 

    let activeMainTop = ((whiteBubbleDiameter - mainActiveBubbleDiameter) / 2) + this.props.top;
    let activeBlueTop = ((whiteBubbleDiameter - diameter) / 2) + this.props.top;
    let activeMainLeft = ((whiteBubbleDiameter - mainActiveBubbleDiameter) / 2);
    let activeBlueLeft = ((whiteBubbleDiameter - diameter) / 2);

    return (
      <CSSTransitionGroup
        component='div'
        className="fastfadedelay"
        style={{ minHeight: '100%' }}
        transitionName='example'
        transitionEnterTimeout={0}
        transitionLeaveTimeout={0}>
        <div key={this.props.active}>
          {
            this.props.active ?
            <div>
              <div style={{ position:"absolute", height: whiteBubbleDiameter, width: whiteBubbleDiameter, borderRadius:"50%", backgroundColor:"white", opacity: 0.5, top: this.props.top }}/>
              <div style={{ position:"absolute", height: diameter, width: diameter, borderRadius:"50%", backgroundColor:this.props.secondaryColor, top: activeBlueTop, left: activeBlueLeft }}/>
              <div style={{ height: mainActiveBubbleDiameter, width: mainActiveBubbleDiameter, borderRadius: "50%", backgroundColor: this.props.primaryColor, display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", top: activeMainTop, left: activeMainLeft }}>
                <div style={{ width:"95%", height:"85%", display:"flex", alignItems:"center", justifyContent:"center" }}>
                  <span className="noselect" style={{ overflow:"hidden", wordBreak:"break-word", maxWidth: this.props.regionWidth * 0.07291666666666666667, fontSize: fontSize, textTransform: "uppercase", textAlign:"center", width:"100%" }}>{this.props.children}</span>
                </div>
              </div>
            </div>
            :
            <div ref={el => this._bubbleRef = el} style={{ height: diameter, width: diameter, borderRadius: "50%", backgroundColor: this.props.primaryColor, display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", top: this.props.top, left: this.props.left }}>
              <span className="noselect" style={{ overflow:"hidden", wordBreak:"break-word", maxWidth: this.props.regionWidth * 0.07291666666666666667, fontSize: fontSize, textTransform: "uppercase", textAlign: "center" }}>{this.props.children}</span>
            </div>
          }
        </div>
      </CSSTransitionGroup>
    );
  }
}

export default SmallBubbleSeattle;


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/SmallBubbleSeattle.jsx